import { create } from 'zustand';
import clsx from 'clsx';
import Icon from './Icon.jsx';
import styles from './Toaster.module.scss';

let nextId = 1;

export const useToasts = create((set, get) => ({
  toasts: [],
  push(toast) {
    const id = nextId++;
    const t = { id, kind: 'info', duration: 4000, ...toast };
    set({ toasts: [...get().toasts.slice(-2), t] });
    if (t.duration > 0) setTimeout(() => get().dismiss(id), t.duration);
    return id;
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
}));

export const toast = {
  info: (message, opts) => useToasts.getState().push({ message, ...opts }),
  success: (message, opts) => useToasts.getState().push({ message, kind: 'success', ...opts }),
  error: (message, opts) =>
    useToasts.getState().push({ message, kind: 'error', duration: 7000, ...opts }),
};

const ICONS = { info: 'info', success: 'check', error: 'warning' };

export default function Toaster() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div className={styles.region} role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={clsx(styles.toast, styles[t.kind])}>
          <span className={styles.icon}>
            <Icon name={ICONS[t.kind] ?? 'info'} size={18} stroke={2.5} />
          </span>
          <span className={styles.msg}>{t.message}</span>
          {t.action ? (
            <button
              type="button"
              className={styles.action}
              onClick={() => {
                t.action.onClick();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          ) : (
            <button type="button" className={styles.x} onClick={() => dismiss(t.id)} aria-label="Dismiss">
              <Icon name="close" size={18} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
